import { createReducer } from 'redux-act';
import { contracts } from './actions';
export const initialState = {};
export const fetchContractsHandler = (state, {
  response,
  label
}) => {
  const contract = response.data;
  return {
    ...state,
    [label]: contract
  };
};
const reducer = createReducer({
  [contracts.fetch.success.getType()]: fetchContractsHandler
}, initialState);
export default reducer;